import {
    getRunData, getRunDataByRunId, getSignalPlotsData, getHistogramPlotsData, getTileAreaAsync, getCirclePlotsData, getRunConfigurationTableData, getPipelineVersionData, getGitRevsData, getPNGData, checkRunIsBarcodedAsync, getBeadsFilteringTableDataAsync,
    getBarcodeStatisticsTableDataAsync, getBERTableDataAsync, getBERHMERTableDataAsync, getRLQTableDataAsync, getFMetricsTableDataAsync, getJSONData, getQTableDataAsync, getBaseCallingReportAsync, getSignalsLinearitTableDataAsync, getOpticsPlotsData, getHistogramPlotsByFlowData,
    getClumpingsTableDataAsync, getHealthPlotsTemperatureDataAsync, getHealthPlotsHumidityDataAsync, getPhasingTableDataAsync, getCovGCBiasTableDataAsync, checkVCReportExistsAsync, getRunDataByRowCount, getRunDataByDate, getAMPData, getAMPPlotsData, getOpticsPlotsLaserData, getImgDeformData,
    getBeadLossData, getSAMReportAsync, getFWHMData, getFWHMDataMany, getTemplateReport, getSupplementReport, getLateFlowMetricsData, getNoiseAndContextData, postAnalysisCommentData, postDetailsData, getH5BerPerFlowPlotData, getAnalysisMetaDataAsync, getVersionsAsync, getH5ReadLengthPlotData,
    getH5MedianRSQPlotData, getBCALLJSONData, getHistogramPlotsDataAll, getReadsPassFilterAsync, getCSVReadsFilteringPlotData, getH5BerPerReadHistPlotData, checkTemplateReportExist, checkBaseCallingReportExistAsync, getRunDataGrouped, getHomoIndelErrorAsync, getH5FlowErrorPlotData,
    getH5PolyPlotDataAsync, getFWHMCSVDataAsync, getAmpRunCSV, getRunInfoDataAsync, getDiskSpaceDataAsync, getCalculatedFreeSpaceeDataAsync, getRunIdDataByDate, deleteRunIdsDataAsync,
    getPpmSeqReportListDataAsync, getRunInfoLengthDataAsync, getOTData, getH5ReadsFilteringPlotData

} from "../../services/apiService";
import {
    LOAD_RUN_LIST_DATA, SET_CURRENT_RUN_DATA, SET_IS_LOADING, GET_SIGNAL_PLOTS_DATA, SET_SIGNAL_PLOTS_RENDER_DATA, GET_HISTOGRAM_PLOTS_DATA, SET_HISTOGRAM_PLOTS_RENDER_DATA, SET_FLOW, SET_TILE_AREA, SET_INSTRUMENT_ID, SET_RUN_ID, GET_CIRCLE_PLOTS_DATA, SET_CIRCLE_PLOTS_RENDER_DATA, SET_IS_SIGNAL_PLOTS_LOADING, SET_IS_HISTOGRAM_PLOTS_LOADING,
    SET_DENSITY_SPINNER, SET_SIGNAL_SPINNER, SET_SNR_SPINNER, SET_STATS_TABLE_DATA, SET_THETA_PROFILING_PLOTS_RENDER_DATA, SET_THETA_PROFILING_PLOTS_RADIUS, GET_RUN_CONFIGURATION_TABLE_DATA, SET_RUN_CONFIGURATION_TABLE_RENDER_DATA, GET_RUN_CONFIGURATION_PLOTS, CHECK_RUN_IS_BARCODED, GET_BEADS_FILTERING_TABLE_DATA,
    SET_BEADS_FILTERING_TABLE_RENDER_DATA, GET_BEADS_FILTERING_PLOTS, GET_BARCODE_STATISTICS_TABLE_DATA, SET_BARCODE_STATISTICS_TABLE_RENDER_DATA, GET_BER_TABLE_DATA, SET_BER_TABLE_RENDER_DATA, GET_BER_HMER_TABLE_DATA, SET_BER_HMER_TABLE_RENDER_DATA, GET_ERROR_PLOTS, GET_RLQ_TABLE_DATA, SET_RLQ_TABLE_RENDER_DATA,
    GET_FMETRICS_TABLE_DATA, SET_FMETRICS_TABLE_RENDER_DATA, GET_BARCODE_COVERAGE_PLOTS, GET_BASE_QUALITY_PLOTS, GET_PHASING_PLOTS, GET_SIGNALS_PLOTS, GET_COVERAGE_GC_PLOTS, GET_UNIFORMITY_PLOTS, GET_UNIFORMITY_SIGNAL_PLOTS, GET_Q_TABLE_DATA, SET_Q_TABLE_RENDER_DATA, GET_HG_BASECALLING_REPORT, GET_EC_BASECALLING_REPORT,
    GET_SIGNALS_LINEARITY_TABLE_DATA, SET_SIGNALS_LINEARITY_TABLE_RENDER_DATA, GET_SIGNALS_LINEARITY_PLOTS, GET_OPTICS_PLOTS_DATA, SET_OPTICS_PLOTS_RENDER_DATA, GET_BEAD_LOSS_PLOTS_DATA, GET_HISTOGRAM_BY_FLOWS_PLOTS_DATA, SET_DENSITY_PLOTS_RENDER_DATA, SET_STATS_DENSITY_TABLE_DATA, GET_CLUMPINGS_TABLE_DATA, SET_CLUMPINGS_TABLE_RENDER_DATA,
    SET_IS_RUN_DATA_LOADING, SET_USER, GET_HEALTH_DATA_TEMPERATURE_PLOTS, SET_HEALTH_DATA_IS_LOADING, SET_HEALTH_DATA_TEMPERATURE_RENDER_DATA, GET_HEALTH_DATA_HUMIDITY_PLOTS, SET_HEALTH_DATA_HUMIDITY_RENDER_DATA, GET_COVERAGE_PLOTS, GET_PHASING_TABLE_DATA, GET_PHASING_TABLE_RENDER_DATA,
    GET_COVGCBIAS_TABLE_DATA, GET_COVGCBIAS_TABLE_RENDER_DATA, CHECK_VCREPORT_EXIST, GET_VCREPORT_PLOTS, IS_MAIN_TABLE_FIRST_PAGE_LOADED, SET_ACTIVE_TAB_NAME, SET_RUN_IS_BARCODED, IS_NUM_FLOWS_100_LOADED, LOAD_AMP_LIST_DATA, SET_IS_AMP_DATA_LOADING, SET_AMP_RUN_ID, SET_CURRENT_AMP_RUN_DATA, GET_AMP_PLOTS_DATA, SET_IS_AMP_PLOTS_DATA_LOADING,
    SET_IS_OPTICS_PLOTS_DATA_LOADING, SET_ACTIVE_INSTR_HEALTH_SUB_TAB_NAME, SET_IS_OPTICS_PLOTS_LASER_DATA_LOADING, GET_OPTICS_PLOTS_LASER_DATA, SET_OPTICS_PLOTS_LASER_RENDER_DATA, GET_IMG_DEFORM_DATA, SET_IS_IMG_DEFORM_PLOTS_DATA_LOADING, SET_IMG_DEFORM_RENDER_DATA, GET_BEAD_LOSS_PLOTS_DATA_CSV, SET_BEAD_LOSS_DATA_LOADING,
    GET_SAM_REPORT, SET_SAM_REPORT_IS_LOADING, GET_FWHM_PLOTS_DATA, SET_FWHM_PLOTS_IS_LOADING, GET_FWHM_PLOTS_CAMERA_DATA, SET_TEMPLATE_REPORT_IS_LOADING, GET_TEMPLATE_REPORT, SET_TEMPLATE_REPORT_RENDER_DATA, SET_ACTIVE_TEMPLATE_REPORT_SUB_TAB_NAME, GET_SUPPLEMENTARY_REPORT, SET_SUPPLEMENTARY_REPORT_IS_LOADING, SET_SUPPLEMENTARY_REPORT_RENDER_DATA,
    SET_LATE_FLOW_METRICS_IS_LOADING, GET_LATE_FLOW_METRICS_DATA, GET_TOOL_NOISE_PLOTS, SET_TOOL_NOISE_PLOTS_IS_LOADING, GET_TOOL_NOISE_TABLE_DATA, SET_TOOL_NOISE_TABLE_DATA_IS_LOADING, SET_CUSTOM_FILTERS, SET_CUSTOM_FILTERS_APPLIED, SET_RUN_LIST_DATA_FILTERED, SET_RUN_LIST_DATA, SET_RUN_LIST_DOWNLOAD_DATA, SET_ALL_RUN_LIST_DATA_SHOWN_BY_FLOW_NUM_100,
    SET_ANALYSIS_COMMENT_DATA_SAVED, SET_DETAILS_DATA_SAVED, SET_ISAUTHENTICATED, LOGOUT_CURRENT_USER, RESET_STATE, SET_EDIT_MODE, SET_RUN_LIST_DATA_SEARCHED, SET_RUN_LIST_DATA_SEARCHED_AMP, SET_NUMBER_OF_CUSTOM_FILTERS_APPLIED, SET_SEARCH_TERM, SET_SEARCH_TERM_AMP, SET_RUN_LIST_AMP_DOWNLOAD_DATA, IS_EDIT_ALLOWED, SET_ERROR_PLOT_IS_LOADING,
    SET_READ_LENGTH_PLOT_IS_LOADING, GET_READ_LENGTH_PLOTS, SET_READ_LENGTH_PLOTS_BY_CAMERA_VALUE, SET_ERROR_PLOTS_BY_CAMERA_VALUE, GET_RSQ_PLOT, SET_RSQ_PLOT_IS_LOADING, GET_POLY_PLOTS, SET_POLY_PLOTS_IS_LOADING, SET_BARCODE_COVERAGE_PLOTS_IS_LOADING, GET_FWHM_PLOTS, SET_RUN_SUMMARY_DENSITY_PLOT_RENDER_DATA,
    GET_RUN_SUMMARY_DENSITY_PLOT_DATA, SET_RUN_SUMMARY_DENSITY_PLOT_IS_LOADING, RUN_SUMMARY_DENSITY_PLOT_BY_CAMERA_VALUE, SET_VERSION, SET_BEADS_FILTERING_PLOTS_IS_LOADING, READS_FILTERING_PLOT_BY_CAMERA_VALUE, SET_FMETRICS_DATA_IS_LOADING, GET_COVERAGE_PLOTS_DATA, GET_COVERAGE_PLOTS_DATA_IS_LOADING, SET_TEMPLATE_REPORT_EXIST,
    SET_HG_BASECALLING_REPORT_EXIST, SET_EC_BASECALLING_REPORT_EXIST, GET_CHART_VIEW_PLOTS_DATA, SET_CHART_VIEW_PLOTS_DATA_IS_LOADING, GET_SIGNALS_PLOTS_PNG, GET_BASE_QUALITY_BER_PER_FLOW_PLOT, SET_ALERT, CLEAR_ALERT, SET_IS_UNIFIED_ROW_SELECTED, GET_HOMO_INDEL_ERROR, SET_POLY_PLOTS_BY_CAMERA_VALUE,
    ADD_PLOTLY_PLOT_TO_LIST, GET_FWHM_CSV_DATA, GET_AMP_SINGLE_RUN_DATA, SET_IS_AMP_SINGLE_RUN_LOADING, SET_BY_CAMERA_VALUE, SET_SHOW_FROZEN_HEADER, SET_JWT, SET_JWT_EXP, SET_CALCULATE_COVERAGE_DATA, GET_RUNINFO_DATA, GET_DISKSPACE, SET_CUSTOM_STORAGE, SET_ALERT_STORAGE_RUN, DELETE_RUN_REQUEST_STATUS, CALCULATED_CUSTOM_STORAGE_SPACE,
    IS_VALID_DATA_LOADING, LOAD_H5PLOT_VALID_DATA, SINGLE_VALID_RUN_DATA, VALIDATION_STATUS, LOAD_VALID_DATA, LOAD_VALID_AMP_DATA, SET_VALID_DATA, SET_H5PLOTS_VALID_DATA, FWHM_VALID_RUN_DATA, ADD_BEADS_FFILTER_TABLE_PDF, ACTIVE_BARCODE_TABLE_BUTTON, ADD_PLOTLY_URI_LIST, ADD_RUN_DETAILS_TABLE_PDF, TIME_ZONE_SELECTED, POPULATE_RUNIDS, SET_IS_IMPORT_FIELD_LOADING, GET_PPMSEQ_REPORT_LIST, SET_COLUMN_TYPE, SET_BARCODE_COVERAGE_BARCODE, SET_EXPANDED_RUNID, CLEAR_EXPANDED_RUNID, CHECK_PPM_DATA_IS_LOADING,
    SET_IS_OT_DATA_LOADING, LOAD_OT_LIST_DATA, SET_SEARCH_TERM_OT, SET_OT_RUN_ID
} from "../constants/action-types";
import * as Utils from '../../utils/utils';

import AuthAPI from '../auth/api';

export const setUser = (user) => {
    return async dispatch => {
        dispatch({ type: SET_USER, payload: user });
    };
}

export const setNumFlows100Loaded = (isLoaded) => {
    return async dispatch => {
        dispatch({ type: IS_NUM_FLOWS_100_LOADED, payload: isLoaded });
    };
}

export const setAmpPlotsDataLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_IS_AMP_PLOTS_DATA_LOADING, payload: isLoading });
    };
}

export const setOpticsPlotsDataLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_IS_OPTICS_PLOTS_DATA_LOADING, payload: isLoading });
    };
}

export const setActiveTabName = (name) => {
    return async dispatch => {
        dispatch({ type: SET_ACTIVE_TAB_NAME, payload: name });
    };
}

export const setActiveInstrHealthSubTabName = (name) => {
    return async dispatch => {
        dispatch({ type: SET_ACTIVE_INSTR_HEALTH_SUB_TAB_NAME, payload: name });
    };
}

export const setActiveTemplateReportSubTabName = (name) => {
    return async dispatch => {
        dispatch({ type: SET_ACTIVE_TEMPLATE_REPORT_SUB_TAB_NAME, payload: name });
    };
}

export const setCurrentRunData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_CURRENT_RUN_DATA, payload: data });
    };
}

export const setCurrentAMPRunData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_CURRENT_AMP_RUN_DATA, payload: data });
    };
}

export const getAMPDataAsync = (jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_AMP_DATA_LOADING, payload: true });

        try {
            const response = await getAMPData(jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            
            dispatch({ type: LOAD_AMP_LIST_DATA, payload: json });
        }
        catch { }
        finally {
            dispatch({ type: SET_IS_AMP_DATA_LOADING, payload: false });
        }
    };
};

export const getAmpSingleRunCSV = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_AMP_SINGLE_RUN_LOADING, payload: true });

        try {
            const response = await getAmpRunCSV(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const csvData = await response.text();

            // Handle File Download Logic
            const blob = new Blob([csvData], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            
            link.href = url;
            link.setAttribute('download', `AMPHealth_${runid}.csv`);
            link.setAttribute('id', 'downloadLink');
            link.style.display = 'none';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Clean up memory

            dispatch({ type: GET_AMP_SINGLE_RUN_DATA, payload: csvData, runid: runid });
        }
        catch {
            dispatch({ type: GET_AMP_SINGLE_RUN_DATA, payload: undefined, runid: runid });
        } 
        finally {
            dispatch({ type: SET_IS_AMP_SINGLE_RUN_LOADING, payload: false });
        }
    };
};
export const getAMPPlotsDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_AMP_PLOTS_DATA_LOADING, payload: true });

        try {
            const response = await getAMPPlotsData(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            
            dispatch({ 
                type: GET_AMP_PLOTS_DATA, 
                payload: json, 
                runid: runid 
            });
        }
        catch { } 
        finally {
            dispatch({ type: SET_IS_AMP_PLOTS_DATA_LOADING, payload: false });
        }
    };
};

export const getRunDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: IS_NUM_FLOWS_100_LOADED, payload: false });
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });

        try {
            const response = await getRunDataByRunId(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            
            const sorted = json
                .filter(f => f.startdatetime !== undefined && f.startdatetime !== null)
                .sort((a, b) => new Date(b.startdatetime) - new Date(a.startdatetime));

            dispatch({ type: LOAD_RUN_LIST_DATA, payload: sorted });
            dispatch({ type: IS_NUM_FLOWS_100_LOADED, payload: true });
        }
        catch { }
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const getRunDataAllAsync = (numFlows, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });

        try {
            const response = await getRunData(numFlows, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            const sorted = json
                .filter(f => f.startdatetime !== undefined && f.startdatetime !== null)
                .sort((a, b) => new Date(b.startdatetime) - new Date(a.startdatetime));

            dispatch({ type: LOAD_RUN_LIST_DATA, payload: sorted });            
            
            dispatch({ 
                type: IS_NUM_FLOWS_100_LOADED, 
                payload: numFlows === undefined 
            });

        }
        catch { }
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const getRunDataAllGroupedAsync = (numFlows, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });

        try {
            const response = await getRunDataGrouped(numFlows, jwt);            
          
            const json = response.ok ? await response.json() : undefined;

            if (json) {
                const sorted = json
                    .filter(f => f.startdatetime !== undefined && f.startdatetime !== null)
                    .sort((a, b) => new Date(b.startdatetime) - new Date(a.startdatetime));

                dispatch({ type: LOAD_RUN_LIST_DATA, payload: sorted });
            }
           
            dispatch({ 
                type: IS_NUM_FLOWS_100_LOADED, 
                payload: numFlows === undefined 
            });

        }
        catch { }
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const getRunDataByNumFlowsAsync = (numFlows, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getRunData(numFlows, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            const sorted = json
                .filter(f => f.startdatetime !== undefined && f.startdatetime !== null)
                .sort((a, b) => new Date(b.startdatetime) - new Date(a.startdatetime));

            dispatch({ type: LOAD_RUN_LIST_DATA, payload: sorted });
           
            if (!numFlows) {
                dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
            }

            dispatch({ type: IS_NUM_FLOWS_100_LOADED, payload: false });
        }
        catch { }
    };
};

export const getRunDataAllByRowCountAsync = (rowCount, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });
        dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: false });

        try {
            const response = await getRunDataByRowCount(rowCount, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ type: LOAD_RUN_LIST_DATA, payload: json });
            dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: true });
           
            if (json && json.length >= 1) {
                dispatch({ type: SET_INSTRUMENT_ID, payload: json[0].sysid });
            }
        }
        catch {
            dispatch({ type: LOAD_RUN_LIST_DATA, payload: [] });
            dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: false });
        }
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const getRunDataAllByDateAsync = (start_date, end_date, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });
        dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: false });

        try {
            const response = await getRunDataByDate(start_date, end_date, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ type: LOAD_RUN_LIST_DATA, payload: json });
            dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: true });
        }
        catch {
            dispatch({ type: LOAD_RUN_LIST_DATA, payload: [] });
            dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: false });
        }
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const setIsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_IS_LOADING, payload: isLoading });
    };
}

export const setIsMainTableFirstPageLoaded = (isLoaded) => {
    return async dispatch => {
        dispatch({ type: IS_MAIN_TABLE_FIRST_PAGE_LOADED, payload: isLoaded });
    };
}

export const setIsRunDataLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: isLoading });
    };
}

export const getSignalPlotsDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_SIGNAL_PLOTS_LOADING, payload: true });

        try {
            const response = await getSignalPlotsData(runid, jwt);
           
            const json = response.ok ? await response.json() : undefined;

            if (json) {
                dispatch({ 
                    type: GET_SIGNAL_PLOTS_DATA, 
                    payload: json, 
                    runid: runid 
                });
            }
        }
        catch { }
        finally {
            dispatch({ type: SET_IS_SIGNAL_PLOTS_LOADING, payload: false });
        }
    };
};

export const setSignalPlotsRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_SIGNAL_PLOTS_RENDER_DATA, payload: data, runid: runid });
    };
}

export const getHistogramPlotsDataAsync = (runid, flow, instrId, tileArea, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_HISTOGRAM_PLOTS_LOADING, payload: true });

        try {
            const histogramPromise = getHistogramPlotsData(runid, flow, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .then(json => (json && json.length) ? json : undefined)
                .catch(() => undefined);

            const promises = [histogramPromise];
           
            if (tileArea !== undefined && tileArea !== null) {
                dispatch({ type: SET_TILE_AREA, payload: tileArea, runid, instrId });
            }
            else {
                const tileAreaPromise = getTileAreaAsync(runid, instrId, jwt)
                    .then(res => res.ok ? res.json() : undefined)
                    .catch(() => undefined);
                promises.push(tileAreaPromise);
            }
           
            const [plotsData, fetchedTileArea] = await Promise.all(promises);
           
            dispatch({ 
                type: GET_HISTOGRAM_PLOTS_DATA, 
                payload: plotsData, 
                runid, 
                flow 
            });
            
            if (fetchedTileArea !== undefined) {
                dispatch(setTileArea(fetchedTileArea, runid, instrId));
            }

        }
        catch { }
        finally {
            dispatch({ type: SET_IS_HISTOGRAM_PLOTS_LOADING, payload: false });
        }
    };
};

export const setHistogramPlotsRenderData = (data, runid, flow) => {
    return async dispatch => {
        dispatch({ type: SET_HISTOGRAM_PLOTS_RENDER_DATA, payload: data, runid: runid, flow: flow });
    };
}

export const setFlow = (flow) => {
    return async dispatch => {
        dispatch({ type: SET_FLOW, payload: flow });
    };
}

export const setTileArea = (tile_area, runid, instrId) => {
    return async dispatch => {
        dispatch({ type: SET_TILE_AREA, payload: tile_area, runid: Utils.getRunIdWithoutCamera(runid), instrId: instrId });
    };
}

export const setInstrumentId = (instrId) => {
    return async dispatch => {
        dispatch({ type: SET_INSTRUMENT_ID, payload: instrId });
    };
}

export const setRunId = (runId) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_ID, payload: runId });
    };
}

export const setAMPRunId = (runId) => {
    return async dispatch => {
        dispatch({ type: SET_AMP_RUN_ID, payload: runId });
    };
}

export const getCirclePlotsDataAsync = (runid, flow, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getCirclePlotsData(runid, flow, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_CIRCLE_PLOTS_DATA, 
                payload: json || [], 
                runid: runid 
            });
        }
        catch { }
    };
};

export const setCirclePlotsRenderData = (data, runid, flow) => {
    return async dispatch => {
        dispatch({ type: SET_CIRCLE_PLOTS_RENDER_DATA, payload: data, runid: runid, flow: flow });
    };
}

export const setIsSignalPlotsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_IS_SIGNAL_PLOTS_LOADING, payload: isLoading });
    };
}

export const setIsHistogramPlotsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_IS_HISTOGRAM_PLOTS_LOADING, payload: isLoading });
    };
}

export const setSpinnerDensity = (spinner) => {
    return async dispatch => {
        dispatch({ type: SET_DENSITY_SPINNER, payload: spinner });
    };
}

export const setSpinnerSignal = (spinner) => {
    return async dispatch => {
        dispatch({ type: SET_SIGNAL_SPINNER, payload: spinner });
    };
}

export const setSpinnerSNR = (spinner) => {
    return async dispatch => {
        dispatch({ type: SET_SNR_SPINNER, payload: spinner });
    };
}

export const setStatsTable1Data = (data, runid, flow) => {
    return async dispatch => {
        dispatch({ type: SET_STATS_TABLE_DATA, payload: data, runid: runid, flow: flow });
    };
}

export const setStatsTableDataDensity = (data) => {
    return async dispatch => {
        dispatch({ type: SET_STATS_DENSITY_TABLE_DATA, payload: data });
    };
}

export const setThetaProfilingPlotsRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_THETA_PROFILING_PLOTS_RENDER_DATA, payload: data, runid: runid });
    };
}

export const setThetaProfilingPlotsRadius = (radius, runid) => {
    return async dispatch => {
        dispatch({ type: SET_THETA_PROFILING_PLOTS_RADIUS, payload: radius, runid: runid });
    };
}

export const getRunConfigTableDataAsync = (runid, flow, jwt) => {
    return async (dispatch) => {
        const fetchData = async (promise) => {
            try {
                const response = await promise;
                return response.ok ? await response.json() : undefined;
            }
            catch {
                return undefined;
            }
        };

        try {
            const results = await Promise.all([
                fetchData(getRunConfigurationTableData(runid, flow, jwt)),
                fetchData(getPipelineVersionData(runid, flow, jwt)),
                fetchData(getGitRevsData(runid, flow, jwt)),
                fetchData(getAnalysisMetaDataAsync(runid, jwt)),
                fetchData(getVersionsAsync(runid, jwt)),
                fetchData(getReadsPassFilterAsync(runid, jwt))
            ]);

            const [rc, pv, gr, am, v, rm] = results;
            const finalResult = [];
            
            const isValid = (data) => data !== undefined && !Utils.isObjectEmpty(data);

            if (isValid(rc)) finalResult.push(rc);
            if (isValid(pv)) finalResult.push(pv);
            if (isValid(gr)) finalResult.push(gr);
            if (isValid(am)) finalResult.push(am);
           
            if (v !== undefined) finalResult.push(v);
            if (rm !== undefined) finalResult.push(rm);

            dispatch({ 
                type: GET_RUN_CONFIGURATION_TABLE_DATA, 
                payload: finalResult.length > 0 ? finalResult : undefined, 
                runid, 
                flow 
            });

        }
        catch {
            dispatch({ 
                type: GET_RUN_CONFIGURATION_TABLE_DATA, 
                payload: undefined, 
                runid, 
                flow 
            });
        }
    };
};

export const setRunConfigTableRenderData = (data, runid, camera) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_CONFIGURATION_TABLE_RENDER_DATA, payload: data, runid: runid, camera: camera });
    };
}

export const getRunConfigurationPlots = (runid, imgName, camera, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_RSQ_PLOT_IS_LOADING, payload: true });

        try {
            const pngPromise = getPNGData(runid, imgName, false, jwt)
                .then(async (res) => {
                    if (!res.ok) return undefined;
                    const json = await res.json();
                    
                    if (json && json.length > 0) {
                        return json.map(m => {
                            const bytes = new Uint8Array(m.data);
                            let binary = '';
                            for (let i = 0; i < bytes.byteLength; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            return window.btoa(binary);
                        });
                    }
                    return [];
                })
                .catch(() => undefined);
           
            const h5Promise = getH5MedianRSQPlotData(runid, 'wafer_map_rsq', camera, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
            
            const [pngResults, h5Data] = await Promise.all([pngPromise, h5Promise]);

            let result = { plot1: undefined, plot2: undefined };
            
            if (h5Data !== undefined) {
                result.plot2 = h5Data;
            }

            if (pngResults && pngResults.length > 0) {
                result.plot1 = pngResults[1];
               
                if (h5Data === undefined && pngResults.length >= 2) {
                    result.plot2 = pngResults[1];
                }
            }

            dispatch({ type: GET_RUN_CONFIGURATION_PLOTS, payload: result, runid });

        }
        catch {
            dispatch({ 
                type: GET_RUN_CONFIGURATION_PLOTS, 
                payload: { plot1: undefined, plot2: undefined }, 
                runid 
            });
        }
        finally {
            dispatch({ type: SET_RSQ_PLOT_IS_LOADING, payload: false });
        }
    };
};

export const checkRunIsBarcoded = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await checkRunIsBarcodedAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const isBarcoded = await response.json();

            dispatch({ 
                type: CHECK_RUN_IS_BARCODED, 
                payload: isBarcoded, 
                runid: runid 
            });
        }
        catch { }
    };
};

export const setRunIsBarcoded = (runid, isRunBarcoded) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_IS_BARCODED, payload: isRunBarcoded, runid: runid });
    };
}

export const getBeadsFilteringTableData = (runid, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getBeadsFilteringTableDataAsync(runid, isRunBarcoded, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_BEADS_FILTERING_TABLE_DATA, 
                payload: json, 
                runid: runid 
            });
        }
        catch {
            dispatch({ 
                type: GET_BEADS_FILTERING_TABLE_DATA, 
                payload: undefined, 
                runid: runid 
            });
        }
    };
};

export const setBeadsFilteringTableRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_BEADS_FILTERING_TABLE_RENDER_DATA, payload: data, runid: runid });
    };
}

export const getBeadsFilteringPlots = (runid, imgName, isRunBarcoded, camera, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_BEADS_FILTERING_PLOTS_IS_LOADING, payload: true });

        try {
            const pngPromise = getPNGData(runid, imgName, isRunBarcoded, jwt)
                .then(async (res) => {
                    if (!res.ok) return { type: 'png', data: undefined };
                    const json = await res.json();
                    
                    if (json && json.length > 0) {
                        const result = json.map(m => {
                            const bytes = new Uint8Array(m.data);
                            let binary = '';
                            for (let i = 0; i < bytes.byteLength; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            return window.btoa(binary);
                        });
                        return { type: 'png', data: { plot1: result[0], plot2: result[1] } };
                    }
                    return { type: 'png', data: undefined };
                })
                .catch(() => ({ type: 'png', data: undefined }));
            
            const h5Promise = getH5ReadsFilteringPlotData(runid, 'reads_counting_data_passed_quality', camera, jwt)
                .then(async (res) => {
                    if (!res.ok) return { type: 'h5', data: undefined };
                    const h5 = await res.json();
                    const isValid = h5 && Object.keys(h5).length !== 0 && h5.constructor === Object;
                    return { type: 'h5', data: isValid ? h5 : undefined };
                })
                .catch(() => ({ type: 'h5', data: undefined }));
           
            const csvPromise = getCSVReadsFilteringPlotData(runid, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
         
            const [pngRes, h5Res, csvRes] = await Promise.all([pngPromise, h5Promise, csvPromise]);
            
            let finalPayload;
            if (csvRes !== undefined) {
                finalPayload = csvRes;
            }
            else if (h5Res?.data !== undefined) {
                finalPayload = h5Res;
            }
            else {
                finalPayload = pngRes;
            }

            dispatch({ 
                type: GET_BEADS_FILTERING_PLOTS, 
                runid, 
                payload: finalPayload, 
                camera 
            });

        }
        catch {
            dispatch({ 
                type: GET_BEADS_FILTERING_PLOTS, 
                runid, 
                payload: undefined, 
                camera 
            });
        }
        finally {
            dispatch({ type: SET_BEADS_FILTERING_PLOTS_IS_LOADING, payload: false });
        }
    };
};

export const getBarcodeStatisticsTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getBarcodeStatisticsTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_BARCODE_STATISTICS_TABLE_DATA, 
                payload: json, 
                runid: runid 
            });
        }
        catch {
            dispatch({ 
                type: GET_BARCODE_STATISTICS_TABLE_DATA, 
                payload: undefined, 
                runid: runid 
            });
        }
    };
};

export const setBarcodeStatisticsTableRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_BARCODE_STATISTICS_TABLE_RENDER_DATA, payload: data, runid: runid });
    };
}

export const getBERTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getBERTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_BER_TABLE_DATA, 
                payload: json 
            });
        } catch { }
    };
};

export const setBERTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_BER_TABLE_RENDER_DATA, payload: data });
    };
}

export const getBERMERTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getBERHMERTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_BER_HMER_TABLE_DATA, 
                payload: json 
            });
        }
        catch { }
    };
};

export const setBERHMERTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_BER_HMER_TABLE_RENDER_DATA, payload: data });
    };
}

export const getErrorPlots = (runid, imgName, isRunBarcoded, camera, jwt) => {
    return async (dispatch) => {
        try {
            const h5Plot1Promise = getH5BerPerReadHistPlotData(runid, 'ber_per_read_hist', camera, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
            
            const h5Plot2Promise = getH5BerPerFlowPlotData(runid, 'ber_per_flow', camera, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
            
            const pngPromise = getPNGData(runid, imgName, isRunBarcoded, jwt)
                .then(async (res) => {
                    if (!res.ok) return undefined;
                    const json = await res.json();
                    if (json && json.length > 0) {
                        const converted = json.map(m => {
                            const bytes = new Uint8Array(m.data);
                            let binary = '';
                            for (let i = 0; i < bytes.byteLength; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            return window.btoa(binary);
                        });
                        return { plot1: converted[0], plot2: converted[1] };
                    }
                    return undefined;
                })
                .catch(() => undefined);
            
            const [h5Plot2, pngs, h5Plot1] = await Promise.all([
                h5Plot2Promise,
                pngPromise,
                h5Plot1Promise
            ]);

            let result = { plot1: undefined, plot2: undefined };
           
            if (h5Plot2 !== undefined) {
                result.plot2 = h5Plot2;
            }
            
            if (h5Plot1 !== undefined) {
                result.plot1 = h5Plot1;
            }
            else if (pngs !== undefined) {
                result.plot1 = pngs.plot1;
                
                const isH5Plot2Empty = !h5Plot2 || Object.keys(h5Plot2).length === 0;
                if (isH5Plot2Empty) {
                    result.plot2 = pngs.plot2;
                }
            }

            dispatch({ 
                type: GET_ERROR_PLOTS, 
                runid, 
                camera, 
                payload: result 
            });

        }
        catch {
            dispatch({ 
                type: GET_ERROR_PLOTS, 
                runid, 
                camera, 
                payload: { plot1: undefined, plot2: undefined } 
            });
        }
    };
};

export const getRLQTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getRLQTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_RLQ_TABLE_DATA, 
                payload: json 
            });
        }
        catch { }
    };
};

export const setRLQTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RLQ_TABLE_RENDER_DATA, payload: data });
    };
}

export const getFMetricsTableData = (runid, barcode, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_FMETRICS_DATA_IS_LOADING, payload: true });

        try {
            const response = await getFMetricsTableDataAsync(runid, barcode, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_FMETRICS_TABLE_DATA, 
                payload: json 
            });
        }
        catch { }
        finally {
            dispatch({ type: SET_FMETRICS_DATA_IS_LOADING, payload: false });
        }
    };
};

export const setFMetricsTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_FMETRICS_TABLE_RENDER_DATA, payload: data });
    };
}

export const setBarcodeCoveragePlotIsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_BARCODE_COVERAGE_PLOTS_IS_LOADING, payload: isLoading });
    };
}

export const geBarcodeCoveragePlots = (runid, imgName, jsonName, barcode, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_BARCODE_COVERAGE_PLOTS_IS_LOADING, payload: true });

        try {
            const pngPromise = getPNGData(runid, imgName, false, jwt)
                .then(async (res) => {
                    if (!res.ok) return undefined;
                    const json = await res.json();
                    if (json && json.length > 0) {
                        return json.map(m => {
                            const bytes = new Uint8Array(m.data);
                            let binary = '';
                            for (let i = 0; i < bytes.byteLength; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            return window.btoa(binary);
                        });
                    }
                    return undefined;
                })
                .catch(() => undefined);
           
            const jsonPromise = getBCALLJSONData(runid, jsonName, barcode, false, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
           
            const [pngData, dbData] = await Promise.all([pngPromise, jsonPromise]);

            let result = {};            
           
            if (pngData !== undefined) {
                result = { type: 'from_file', data: pngData };
            } 
            else if (dbData !== undefined) {
                result = { type: 'from_db', data: dbData };
            }

            const barcodeData = { barcode, data: result };

            dispatch({ 
                type: GET_BARCODE_COVERAGE_PLOTS, 
                runid, 
                payload: { data: [barcodeData], type: result.type } 
            });

            dispatch({ 
                type: SET_CALCULATE_COVERAGE_DATA, 
                runid, 
                payload: result.data 
            });

        }
        catch {
            dispatch({ 
                type: GET_BARCODE_COVERAGE_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
        finally {
            dispatch({ type: SET_BARCODE_COVERAGE_PLOTS_IS_LOADING, payload: false });
        }
    };
};

export const geBaseQualityPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        try {
            const pngPromise = getPNGData(runid, imgName, false, jwt)
                .then(async (res) => {
                    if (!res.ok) return undefined;
                    const json = await res.json();
                    if (json && json.length > 0) {
                        return json.map(m => {
                            const bytes = new Uint8Array(m.data);
                            let binary = '';
                            for (let i = 0; i < bytes.byteLength; i++) {
                                binary += String.fromCharCode(bytes[i]);
                            }
                            return window.btoa(binary);
                        });
                    }
                    return undefined;
                })
                .catch(() => undefined);
            
            const jsonPromise = getJSONData(runid, `${imgName}_JSON`, false, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
           
            const unifiedRunId = Utils.getRunIdWithoutCamera(runid);
            const unifiedJsonPromise = getJSONData(unifiedRunId, `${imgName}_JSON`, false, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);
           
            const [pngData, dbData, unifiedData] = await Promise.all([
                pngPromise,
                jsonPromise,
                unifiedJsonPromise
            ]);

            let result = undefined;
            
            if (unifiedData !== undefined) {
                result = { type: 'from_db', data: unifiedData };
            }
            else if (dbData !== undefined) {
                result = { type: 'from_db', data: dbData };
            }
            else if (pngData !== undefined) {
                result = { type: 'from_file', data: pngData };
            }

            dispatch({ 
                type: GET_BASE_QUALITY_PLOTS, 
                runid, 
                payload: result 
            });

        }
        catch {
            dispatch({ 
                type: GET_BASE_QUALITY_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const gePhasingPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        try {
            const fetchPhasingData = async (targetId) => {
                try {
                    const response = await getJSONData(targetId, imgName, false, jwt);
                    return response.ok ? await response.json() : undefined;
                } catch {
                    return undefined;
                }
            };
            
            const standardPromise = fetchPhasingData(runid);
            const unifiedPromise = fetchPhasingData(Utils.getRunIdWithoutCamera(runid));
           
            const [standardData, unifiedData] = await Promise.all([
                standardPromise, 
                unifiedPromise
            ]);
          
            const finalPayload = unifiedData ?? standardData;

            dispatch({ 
                type: GET_PHASING_PLOTS, 
                runid, 
                payload: finalPayload 
            });

        }
        catch {
            dispatch({ 
                type: GET_PHASING_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const geSignalsPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        try {
            const fetchSignalData = async (targetId) => {
                try {
                    const response = await getJSONData(targetId, imgName, false, jwt);
                    return response.ok ? await response.json() : undefined;
                } catch {
                    return undefined;
                }
            };
           
            const standardPromise = fetchSignalData(runid);
            const unifiedPromise = fetchSignalData(Utils.getRunIdWithoutCamera(runid));
            
            const [standardData, unifiedData] = await Promise.all([
                standardPromise,
                unifiedPromise
            ]);
           
            const finalPayload = unifiedData ?? standardData;

            dispatch({ 
                type: GET_SIGNALS_PLOTS, 
                runid, 
                payload: finalPayload 
            });

        }
        catch {
            dispatch({ 
                type: GET_SIGNALS_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const geSignalsPlotsPNG = (runid, imgName, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getPNGData(runid, imgName, false, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json && json.length > 0) {
                const result = json.map(m => {
                    const bytes = new Uint8Array(m.data);
                    let binary = '';
                    for (let i = 0; i < bytes.byteLength; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    return window.btoa(binary);
                });

                dispatch({ 
                    type: GET_SIGNALS_PLOTS_PNG, 
                    runid, 
                    payload: result 
                });
            }
            else {
                dispatch({ 
                    type: GET_SIGNALS_PLOTS_PNG, 
                    runid, 
                    payload: undefined 
                });
            }
        }
        catch {
            dispatch({ 
                type: GET_SIGNALS_PLOTS_PNG, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const geCoverageGCPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        const fetchData = (id) => 
            getJSONData(id, imgName, false, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);

        try {
            const [jsons, jsonsUnified] = await Promise.all([
                fetchData(runid),
                fetchData(Utils.getRunIdWithoutCamera(runid))
            ]);
           
            const result = jsonsUnified ?? jsons;

            dispatch({ 
                type: GET_COVERAGE_GC_PLOTS, 
                runid, 
                payload: result 
            });
        }
        catch (error) {
            dispatch({ 
                type: GET_COVERAGE_GC_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const getUniformityPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        const unifiedRunId = Utils.getRunIdWithoutCamera(runid);
        
        const fetchJSON = (id, name) => 
            getJSONData(id, name, false, jwt)
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);

        try {           
            const [jsons, jsonsUnified, jsonsX, jsonsUnifiedX] = await Promise.all([
                fetchJSON(runid, imgName),
                fetchJSON(unifiedRunId, imgName),
                fetchJSON(runid, `${imgName}_X`),
                fetchJSON(unifiedRunId, `${imgName}_X`)
            ]);
          
            const result = {
                U: jsonsUnified ?? jsons ?? [],
                U_X: jsonsUnifiedX ?? jsonsX ?? []
            };

            dispatch({ 
                type: GET_UNIFORMITY_PLOTS, 
                runid, 
                payload: result 
            });

        }
        catch (error) {           
            dispatch({ 
                type: GET_UNIFORMITY_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const getUniformitySignalPlots = (runid, imgName, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        const fetchAndProcessPNG = async (id) => {
            try {
                const response = await getPNGData(id, imgName, isRunBarcoded, jwt);
                if (!response.ok) return undefined;
                
                const json = await response.json();
                if (!Array.isArray(json) || json.length === 0) return undefined;
               
                return json.map(m => bufferToBase64(m.data));
            }
            catch (error) {
                return undefined;
            }
        };

        try {
            const [pngs, pngsUnified] = await Promise.all([
                fetchAndProcessPNG(runid),
                fetchAndProcessPNG(Utils.getRunIdWithoutCamera(runid))
            ]);
           
            const result = pngsUnified ?? pngs;

            dispatch({ 
                type: GET_UNIFORMITY_SIGNAL_PLOTS, 
                runid, 
                payload: result 
            });
        }
        catch (error) {
            dispatch({ 
                type: GET_UNIFORMITY_SIGNAL_PLOTS, 
                runid, 
                payload: undefined 
            });
        }
    };
};

export const getQTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getQTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            
            dispatch({ 
                type: GET_Q_TABLE_DATA, 
                payload: { ...json } 
            });
        }
        catch (error) {
            dispatch({ 
                type: GET_Q_TABLE_DATA, 
                payload: undefined 
            });
        }
    };
};

export const setQTableRenderData = (data, type) => {
    return async dispatch => {
        dispatch({ type: SET_Q_TABLE_RENDER_DATA, payload: { data: data, type: type } });
    };
}

export const getBaseCallingReport = (runid, type, jwt) => {
    return async (dispatch) => {
        const actionMap = {
            'HG': GET_HG_BASECALLING_REPORT,
            'EC': GET_EC_BASECALLING_REPORT
        };

        try {
            const response = await getBaseCallingReportAsync(runid, type, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
           
            if (json && actionMap[type]) {
                dispatch({ 
                    type: actionMap[type], 
                    payload: json 
                });
            }
        }
        catch { }
    };
};

export const checkBaseCallingReportExist = (runid, type, jwt) => {
    return async (dispatch) => {
        try {
            const existResponse = await checkBaseCallingReportExistAsync(runid, type, jwt);
            if (!existResponse.ok) throw Error(existResponse.statusText);
            
            const exists = await existResponse.json();

            if (exists) {
                if (type === 'HG') dispatch({ type: SET_HG_BASECALLING_REPORT_EXIST, payload: exists });
                else if (type === 'EC') dispatch({ type: SET_EC_BASECALLING_REPORT_EXIST, payload: exists });
                
                if (exists === true) {
                    try {
                        const reportResponse = await getBaseCallingReportAsync(runid, type, jwt);
                        if (!reportResponse.ok) throw Error(reportResponse.statusText);
                        
                        const reportJson = await reportResponse.json();
                        
                        if (reportJson) {
                            if (type === 'HG') dispatch({ type: GET_HG_BASECALLING_REPORT, payload: reportJson });
                            else if (type === 'EC') dispatch({ type: GET_EC_BASECALLING_REPORT, payload: reportJson });
                        }
                    }
                    catch {                       
                        if (type === 'HG') dispatch({ type: GET_HG_BASECALLING_REPORT, payload: undefined });
                        else if (type === 'EC') dispatch({ type: GET_EC_BASECALLING_REPORT, payload: undefined });
                    }
                }
            }
            else {
                if (type === 'HG') {
                    dispatch({ type: SET_HG_BASECALLING_REPORT_EXIST, payload: false });
                    dispatch({ type: GET_HG_BASECALLING_REPORT, payload: undefined });
                }
                else if (type === 'EC') {
                    dispatch({ type: SET_EC_BASECALLING_REPORT_EXIST, payload: false });
                    dispatch({ type: GET_EC_BASECALLING_REPORT, payload: undefined });
                }
            }
        }
        catch (error) {
            if (type === 'HG') {
                dispatch({ type: SET_HG_BASECALLING_REPORT_EXIST, payload: false });
                dispatch({ type: GET_HG_BASECALLING_REPORT, payload: undefined });
            }
            else if (type === 'EC') {
                dispatch({ type: SET_EC_BASECALLING_REPORT_EXIST, payload: false });
                dispatch({ type: GET_EC_BASECALLING_REPORT, payload: undefined });
            }
        }
    };
};

export const getSAMReport = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_SAM_REPORT_IS_LOADING, payload: true });

        try {
            const response = await getSAMReportAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
           
            dispatch({ 
                type: GET_SAM_REPORT, 
                payload: json || [], 
                runid: runid 
            });

        }
        catch {}
        finally {
            dispatch({ type: SET_SAM_REPORT_IS_LOADING, payload: false });
        }
    };
};

export const getSignalsLinearityTableData = (runid, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getSignalsLinearitTableDataAsync(runid, isRunBarcoded, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_SIGNALS_LINEARITY_TABLE_DATA, 
                payload: json 
            });
        } 
        catch { }
    };
};

export const setSignalsLinearityTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_SIGNALS_LINEARITY_TABLE_RENDER_DATA, payload: data });
    };
}

export const getSignalsLinearityPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getJSONData(runid, imgName, false, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
          
            if (json) {
                dispatch({ 
                    type: GET_SIGNALS_LINEARITY_PLOTS, 
                    payload: json 
                });
            }
        }
        catch (error) {
            dispatch({ 
                type: GET_SIGNALS_LINEARITY_PLOTS, 
                payload: [] 
            });
        }
    };
};

export const getOpticsPlotsDataAsync = (runid, flow, type, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_OPTICS_PLOTS_DATA_LOADING, payload: true });

        try {
            const response = await getOpticsPlotsData(runid, flow, type, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            
            dispatch({ 
                type: GET_OPTICS_PLOTS_DATA, 
                payload: json ?? undefined, 
                runid, 
                flow, 
                beadsType: type 
            });

        }
        catch (error) {
            dispatch({ 
                type: GET_OPTICS_PLOTS_DATA, 
                payload: undefined, 
                runid, 
                flow, 
                beadsType: type 
            });
        } 
        finally {
            dispatch({ type: SET_IS_OPTICS_PLOTS_DATA_LOADING, payload: false });
        }
    };
};

export const getOpticsPlotsLaserDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_OPTICS_PLOTS_LASER_DATA_LOADING, payload: true });

        try {
            const response = await getOpticsPlotsLaserData(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
           
            dispatch({ 
                type: GET_OPTICS_PLOTS_LASER_DATA, 
                payload: json || [], 
                runid 
            });
        }
        catch (error) {
            dispatch({ 
                type: GET_OPTICS_PLOTS_LASER_DATA, 
                payload: [], 
                runid 
            });
        } 
        finally {
            dispatch({ type: SET_IS_OPTICS_PLOTS_LASER_DATA_LOADING, payload: false });
        }
    };
};

export const setOpticsPlotsRenderData = (data, runid, flow, type) => {
    return async dispatch => {
        dispatch({ type: SET_IS_OPTICS_PLOTS_DATA_LOADING, payload: true });
        dispatch({ type: SET_OPTICS_PLOTS_RENDER_DATA, payload: data, runid: runid, flow: flow, beadsType: type });
        dispatch({ type: SET_IS_OPTICS_PLOTS_DATA_LOADING, payload: false });
    };
}

export const setOpticsPlotsLaserRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_IS_OPTICS_PLOTS_LASER_DATA_LOADING, payload: true });
        dispatch({ type: SET_OPTICS_PLOTS_LASER_RENDER_DATA, payload: data, runid: runid });
        dispatch({ type: SET_IS_OPTICS_PLOTS_LASER_DATA_LOADING, payload: false });
    };
}

export const getBeadLossPlots = (runid, imgName, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_BEAD_LOSS_DATA_LOADING, payload: true });
      
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        try {
            const csvResponse = await getBeadLossData(runid, jwt);
            const csvData = csvResponse.ok ? await csvResponse.json() : null;

            if (csvData) {
                dispatch({ type: GET_BEAD_LOSS_PLOTS_DATA_CSV, payload: csvData, runid });
            }
            else {
                const pngResponse = await getPNGData(runid, imgName, isRunBarcoded, jwt);
                if (!pngResponse.ok) throw new Error(pngResponse.statusText);

                const pngJson = await pngResponse.json();

                if (pngJson && pngJson.length > 0) {
                    const result = pngJson.map(m => bufferToBase64(m.data));
                    dispatch({ type: GET_BEAD_LOSS_PLOTS_DATA, payload: result, runid });
                }
            }
        }
        catch { }
        finally {
            dispatch({ type: SET_BEAD_LOSS_DATA_LOADING, payload: false });
        }
    };
};

export const getHistogramPlotsDataByFlowAsync = (runid, instrId, flowArr, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_HISTOGRAM_PLOTS_LOADING, payload: true });

        const fetchData = (promise) =>
            promise
                .then(res => res.ok ? res.json() : undefined)
                .catch(() => undefined);

        try {
            const [tileArea, histogramData] = await Promise.all([
                fetchData(getTileAreaAsync(runid, instrId, jwt)),
                fetchData(getHistogramPlotsByFlowData(runid, flowArr, jwt))
            ]);

            if (tileArea !== undefined) {
                dispatch(setTileArea(tileArea, runid, instrId));
            }

            if (histogramData !== undefined) {
                dispatch({ 
                    type: GET_HISTOGRAM_BY_FLOWS_PLOTS_DATA, 
                    payload: histogramData, 
                    runid 
                });
            }
        }
        catch { }
        finally {
            dispatch({ type: SET_IS_HISTOGRAM_PLOTS_LOADING, payload: false });
        }
    };
};

export const setHistogramPlotsByFlowRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_DENSITY_PLOTS_RENDER_DATA, payload: data, runid: runid });
    };
}

export const getClumpingsTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getClumpingsTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_CLUMPINGS_TABLE_DATA, 
                payload: json 
            });
        } 
        catch { }
    };
};

export const setClumpingsTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_CLUMPINGS_TABLE_RENDER_DATA, payload: data });
    };
}

export const getHealthPlotsTemperatureData = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: true });

        try {
            const response = await getHealthPlotsTemperatureDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
          
            let result = [];
            if (json?.file?.length > 0) {
                result = json.file;
            }
            else if (json?.database?.length > 0) {
                result = json.database;
            }

            dispatch({ 
                type: GET_HEALTH_DATA_TEMPERATURE_PLOTS, 
                payload: result, 
                runid 
            });
        } 
        catch {
            dispatch({ type: GET_HEALTH_DATA_TEMPERATURE_PLOTS, payload: [], runid });
        } 
        finally {
            dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: false });
        }
    };
};

export const setHealtDataTemperaturePlotRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: true });
        dispatch({ type: SET_HEALTH_DATA_TEMPERATURE_RENDER_DATA, payload: data, runid: runid });
        dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: false });
    };
}

export const getHealthPlotsHumidityData = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: true });

        try {
            const response = await getHealthPlotsHumidityDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            
            let result = [];
            if (json?.file?.length > 0) {
                result = json.file;
            }
            else if (json?.database?.length > 0) {
                result = json.database;
            }

            dispatch({ 
                type: GET_HEALTH_DATA_HUMIDITY_PLOTS, 
                payload: result, 
                runid 
            });
        } 
        catch {
            dispatch({ type: GET_HEALTH_DATA_HUMIDITY_PLOTS, payload: [], runid });
        } 
        finally {
            dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: false });
        }
    };
};

export const setHealtDataHumidityPlotRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: true });
        dispatch({ type: SET_HEALTH_DATA_HUMIDITY_RENDER_DATA, payload: data, runid: runid });
        dispatch({ type: SET_HEALTH_DATA_IS_LOADING, payload: false });
    };
}

export const getCoveragePlots = (runid, imgName, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        try {
            const response = await getPNGData(runid, imgName, isRunBarcoded, jwt);
            
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json && json.length > 0) {
                const result = json.map(m => bufferToBase64(m.data));
               
                const payload = !isRunBarcoded 
                    ? { plot1: result[0], plot2: result[1], plot3: result[2] } 
                    : { plot1: result[0], plot2: result[1] };

                dispatch({ 
                    type: GET_COVERAGE_PLOTS, 
                    payload 
                });
            }
        } 
        catch { }
    };
};

export const getPhasingTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getPhasingTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_PHASING_TABLE_DATA, 
                payload: json 
            });
        } 
        catch (error) {
            dispatch({ 
                type: GET_PHASING_TABLE_DATA, 
                payload: undefined 
            });
        }
    };
};

export const setPhasingTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: GET_PHASING_TABLE_RENDER_DATA, payload: data });
    };
}

export const getCovGCBiasTableData = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getCovGCBiasTableDataAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_COVGCBIAS_TABLE_DATA, 
                payload: json 
            });
        } 
        catch (error) {
            dispatch({ 
                type: GET_COVGCBIAS_TABLE_DATA, 
                payload: undefined 
            });
        }
    };
};

export const setCovGCBiasTableRenderData = (data) => {
    return async dispatch => {
        dispatch({ type: GET_COVGCBIAS_TABLE_RENDER_DATA, payload: data });
    };
}

export const checkVCReportExists = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await checkVCReportExistsAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: CHECK_VCREPORT_EXIST, 
                payload: json 
            });
        } 
        catch { }
    };
};

export const getVCReportPlots = (runid, imgName, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        try {
            const response = await getPNGData(runid, imgName, isRunBarcoded, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json && json.length > 0) {
                const result = json.map(m => bufferToBase64(m.data));
                
                dispatch({ 
                    type: GET_VCREPORT_PLOTS, 
                    payload: result 
                });
            }
        } 
        catch { }
    };
};

export const getImgDeformDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_IMG_DEFORM_PLOTS_DATA_LOADING, payload: true });

        try {
            const response = await getImgDeformData(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_IMG_DEFORM_DATA, 
                payload: json, 
                runid 
            });
        } 
        catch { } 
        finally {
            dispatch({ type: SET_IS_IMG_DEFORM_PLOTS_DATA_LOADING, payload: false });
        }
    };
};

export const setImgDeformRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_IMG_DEFORM_RENDER_DATA, payload: data, runid: runid });
    };
}

export const getFWHMDataAsync = (runid, byCamera, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_FWHM_PLOTS_IS_LOADING, payload: true });

        try {
            const response = await getFWHMData(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
          
            const actionType = byCamera === true 
                ? GET_FWHM_PLOTS_CAMERA_DATA 
                : GET_FWHM_PLOTS_DATA;

            dispatch({ 
                type: actionType, 
                payload: json, 
                runid 
            });
        } 
        catch { } 
        finally {
            dispatch({ type: SET_FWHM_PLOTS_IS_LOADING, payload: false });
        }
    };
};

export const setIsFWHMPlotsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_FWHM_PLOTS_IS_LOADING, payload: isLoading });
    };
}

export const getFWHMDataManyAsync = (runids, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_FWHM_PLOTS_IS_LOADING, payload: true });

        try {
            const response = await getFWHMDataMany(runids, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json) {
                dispatch({ 
                    type: GET_FWHM_PLOTS_CAMERA_DATA, 
                    payload: json 
                });
            }
        } 
        catch { } 
        finally {
            dispatch({ type: SET_FWHM_PLOTS_IS_LOADING, payload: false });
        }
    };
};

export const setIsTemplateReportLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_TEMPLATE_REPORT_IS_LOADING, payload: isLoading });
    };
}

export const checkTemplateReportExistAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_TEMPLATE_REPORT_IS_LOADING, payload: true });

        try {
            const existResponse = await checkTemplateReportExist(runid, jwt);
            if (!existResponse.ok) throw new Error(existResponse.statusText);
            
            const exists = await existResponse.json();

            if (exists === true) {
                dispatch({ type: SET_TEMPLATE_REPORT_EXIST, payload: true, runid });

                const reportResponse = await getTemplateReport(runid, jwt);
                if (!reportResponse.ok) throw new Error(reportResponse.statusText);

                const reportData = await reportResponse.json();
                dispatch({ 
                    type: GET_TEMPLATE_REPORT, 
                    payload: reportData ?? undefined, 
                    runid 
                });
            }
            else {
                dispatch({ type: SET_TEMPLATE_REPORT_EXIST, payload: false, runid });
            }
        } 
        catch { } 
        finally {
            dispatch({ type: SET_TEMPLATE_REPORT_IS_LOADING, payload: false });
        }
    };
};

export const setTemplateReportRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_TEMPLATE_REPORT_RENDER_DATA, payload: data, runid: runid });
    };
}

export const setIsSupplementReportLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_SUPPLEMENTARY_REPORT_IS_LOADING, payload: isLoading });
    };
}

export const getSupplementReportAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_SUPPLEMENTARY_REPORT_IS_LOADING, payload: true });

        try {
            const response = await getSupplementReport(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_SUPPLEMENTARY_REPORT, 
                payload: json ?? undefined, 
                runid 
            });
        } 
        catch { } 
        finally {
            dispatch({ type: SET_SUPPLEMENTARY_REPORT_IS_LOADING, payload: false });
        }
    };
};

export const setSupplementReportRenderData = (data, runid) => {
    return async dispatch => {
        dispatch({ type: SET_SUPPLEMENTARY_REPORT_RENDER_DATA, payload: data, runid: runid });
    };
}

export const setIsLateFlowMetricsDataLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_LATE_FLOW_METRICS_IS_LOADING, payload: isLoading });
    };
}

export const getLateFLowMetricsDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_LATE_FLOW_METRICS_IS_LOADING, payload: true });

        try {
            const response = await getLateFlowMetricsData(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_LATE_FLOW_METRICS_DATA, 
                payload: json ?? undefined, 
                runid 
            });
        } 
        catch {
            dispatch({ 
                type: GET_LATE_FLOW_METRICS_DATA, 
                payload: undefined, 
                runid 
            });
        } 
        finally {
            dispatch({ type: SET_LATE_FLOW_METRICS_IS_LOADING, payload: false });
        }
    };
};

export const getToolNoisePlots = (runid, imgName, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_TOOL_NOISE_PLOTS_IS_LOADING, payload: true });

        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        try {
            const response = await getPNGData(runid, imgName, isRunBarcoded, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json && json.length > 0) {
                const result = json.map(m => bufferToBase64(m.data));

                dispatch({ 
                    type: GET_TOOL_NOISE_PLOTS, 
                    payload: { 
                        plot1: result[0], 
                        plot2: result[1], 
                        plot3: result[2], 
                        plot4: result[3] 
                    }, 
                    runid 
                });
            }
        } 
        catch {
            dispatch({ 
                type: GET_TOOL_NOISE_PLOTS, 
                payload: undefined, 
                runid 
            });
        } 
        finally {
            dispatch({ type: SET_TOOL_NOISE_PLOTS_IS_LOADING, payload: false });
        }
    };
};

export const getNoiseAndContextDataAsync = (runid, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_TOOL_NOISE_TABLE_DATA_IS_LOADING, payload: true });

        try {
            const response = await getNoiseAndContextData(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_TOOL_NOISE_TABLE_DATA, 
                payload: json ?? undefined, 
                runid 
            });
        } 
        catch {
            dispatch({ 
                type: GET_TOOL_NOISE_TABLE_DATA, 
                payload: undefined, 
                runid 
            });
        } 
        finally {
            dispatch({ type: SET_TOOL_NOISE_TABLE_DATA_IS_LOADING, payload: false });
        }
    };
};

export const setCustomFilters = (data) => {
    return async dispatch => {
        dispatch({ type: SET_CUSTOM_FILTERS, payload: data });
    };
}

export const setCustomFiltersApplied = (isApplied) => {
    return async dispatch => {
        dispatch({ type: SET_CUSTOM_FILTERS_APPLIED, payload: isApplied });
    };
}

export const setRunListDataFiltered = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_LIST_DATA_FILTERED, payload: data });
    };
}

export const setRunListData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_LIST_DATA, payload: data });
    };
}

export const setRunListDataSearched = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_LIST_DATA_SEARCHED, payload: data });
    };
}

export const setRunListDataSearchedAMP = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_LIST_DATA_SEARCHED_AMP, payload: data });
    };
}

export const setRunListDownloadData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_LIST_DOWNLOAD_DATA, payload: data });
    };
}

export const setRunListAMPDownloadData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_LIST_AMP_DOWNLOAD_DATA, payload: data });
    };
}

export const setIsAllRunListDataShown = (isAll) => {
    return async dispatch => {
        dispatch({ type: SET_ALL_RUN_LIST_DATA_SHOWN_BY_FLOW_NUM_100, payload: isAll });
    };
}

export const saveAnalysisCommentData = (runid, data, runlist, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });
        dispatch({ type: SET_ANALYSIS_COMMENT_DATA_SAVED, payload: false });

        try {
            const response = await postAnalysisCommentData(runid, data, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            await response.json();
           
            if (runlist) {
                const targetId = runid.includes('_') ? runid.split('_')[0] : runid;
                const objIndex = runlist.findIndex(obj => obj.runid === targetId);

                if (objIndex !== -1) {
                    const comment = data.data;
                    runlist[objIndex].analysiscomment = comment;
                   
                    if (runlist[objIndex].subRows?.length > 0) {
                        runlist[objIndex].subRows.forEach(row => {
                            row.analysiscomment = comment;
                        });
                    }

                    dispatch({ type: LOAD_RUN_LIST_DATA, payload: [...runlist] });
                }
            }

            dispatch({ type: SET_ANALYSIS_COMMENT_DATA_SAVED, payload: true });
            dispatch({ type: SET_EDIT_MODE, payload: false });
        } 
        catch {
            dispatch({ type: SET_ANALYSIS_COMMENT_DATA_SAVED, payload: false });
            dispatch({ type: SET_EDIT_MODE, payload: false });
        } 
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const saveDetailsData = (runid, data, runlist, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });
        dispatch({ type: SET_DETAILS_DATA_SAVED, payload: false });

        try {
            const response = await postDetailsData(runid, data, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            await response.json();
           
            if (runlist) {
                const objIndex = runlist.findIndex(obj => obj.runid === runid);
                
                if (objIndex !== -1) {
                    runlist[objIndex].details = data.data;
                    dispatch({ type: LOAD_RUN_LIST_DATA, payload: [...runlist] });
                }
            }

            dispatch({ type: SET_DETAILS_DATA_SAVED, payload: true });
        } 
        catch {
            dispatch({ 
                type: SET_ALERT, 
                payload: { 
                    errorMessage: `Unable to edit the Details field for runid: ${runid}. Run is still in progress. Changes were not saved.`, 
                    errorCode: 'Warning', 
                    errorType: 'warning' 
                } 
            });
            dispatch({ type: SET_DETAILS_DATA_SAVED, payload: false });
        } 
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
            dispatch({ type: SET_EDIT_MODE, payload: false });
        }
    };
};

export const setAnalysisCommentDataSaved = (isSaved) => {
    return async dispatch => {
        dispatch({ type: SET_ANALYSIS_COMMENT_DATA_SAVED, payload: isSaved });
    };
}

export const setDetailsDataSaved = (isSaved) => {
    return async dispatch => {
        dispatch({ type: SET_DETAILS_DATA_SAVED, payload: isSaved });
    };
}

export const setIsAuthenticated = (data) => {
    return async dispatch => {
        dispatch({ type: SET_ISAUTHENTICATED, payload: data });
    };
}

export const logOutCurrentUser = () => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: true });

        try {
            await AuthAPI.logOut();
            dispatch({ type: LOGOUT_CURRENT_USER, payload: undefined });
        } 
        catch { } 
        finally {
            dispatch({ type: SET_IS_RUN_DATA_LOADING, payload: false });
        }
    };
};

export const resetState = () => {
    return async dispatch => {
        dispatch({ type: RESET_STATE });
    };
}

export const setEditMode = (isInEditMode) => {
    return async dispatch => {
        dispatch({ type: SET_EDIT_MODE, payload: isInEditMode });
    };
}

export const setNumberOfCustomFiltersApplied = (number) => {
    return async dispatch => {
        dispatch({ type: SET_NUMBER_OF_CUSTOM_FILTERS_APPLIED, payload: number });
    };
}

export const setSearchTerm = (searchWords, searchColumn) => {
    return async dispatch => {
        dispatch({ type: SET_SEARCH_TERM, payload: { searchWords, searchColumn } });
    };
}

export const setSearchTermAMP = (searchWords, searchColumn) => {
    return async dispatch => {
        dispatch({ type: SET_SEARCH_TERM_AMP, payload: { searchWords, searchColumn } });
    };
}

export const setEditAllowed = (user) => {
    return async dispatch => {
        dispatch({ type: IS_EDIT_ALLOWED, payload: user });
    };
}

export const setErrorPlotLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_ERROR_PLOT_IS_LOADING, payload: isLoading });
    };
}

export const setReadLengthPlotLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_READ_LENGTH_PLOT_IS_LOADING, payload: isLoading });
    };
}

export const getReadLengthPlots = (runid, camera, jwt) => {
    return async (dispatch) => {
        const fetchPlotData = async (fetchPromise) => {
            try {
                const response = await fetchPromise;
                return response.ok ? await response.json() : undefined;
            }
            catch {
                return undefined;
            }
        };

        try {
            const [plot1, plot2, plot3] = await Promise.all([
                fetchPlotData(getH5ReadLengthPlotData(runid, 'count_of_read_length_UG-SpikeIn', camera, jwt)),
                fetchPlotData(getH5FlowErrorPlotData(runid, 'flow_error_TT', camera, jwt)),
                fetchPlotData(getH5ReadLengthPlotData(runid, 'count_of_read_length_total', camera, jwt))
            ]);

            dispatch({
                type: GET_READ_LENGTH_PLOTS,
                runid,
                camera,
                payload: { plot1, plot2, plot3 }
            });
        }
        catch {
            dispatch({
                type: GET_READ_LENGTH_PLOTS,
                runid,
                camera,
                payload: { plot1: undefined, plot2: undefined, plot3: undefined }
            });
        }
    };
};

export const setReadLengthPlotsByCameraValue = (camera) => {
    return async dispatch => {
        dispatch({ type: SET_READ_LENGTH_PLOTS_BY_CAMERA_VALUE, payload: camera });
    };
}

export const setErrorPlotsByCameraValue = (camera) => {
    return async dispatch => {
        dispatch({ type: SET_ERROR_PLOTS_BY_CAMERA_VALUE, payload: camera });
    };
}

export const getMedianRSQPlots = (runid, camera, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_RSQ_PLOT_IS_LOADING, payload: true });

        try {
            const response = await getH5MedianRSQPlotData(runid, 'wafer_map_rsq', camera, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const h5 = await response.json();

            dispatch({ 
                type: GET_RSQ_PLOT, 
                runid, 
                camera, 
                payload: { h5 } 
            });
        } 
        catch {
            dispatch({ 
                type: GET_RSQ_PLOT, 
                runid, 
                camera, 
                payload: { h5: undefined } 
            });
        } 
        finally {
            dispatch({ type: SET_RSQ_PLOT_IS_LOADING, payload: false });
        }
    };
};

export const setRSQPlotLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_RSQ_PLOT_IS_LOADING, payload: isLoading });
    };
}

export const setPolyPlotsByCameraValue = (value) => {
    return async dispatch => {
        dispatch({ type: SET_POLY_PLOTS_BY_CAMERA_VALUE, payload: value });
    };
}

export const getPolyPlots = (runid, imgName, isRunBarcoded, camera, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_POLY_PLOTS_IS_LOADING, payload: true });
       
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };
      
        const fetchPng = async () => {
            try {
                const response = await getPNGData(runid, imgName, isRunBarcoded, jwt);
                if (!response.ok) return undefined;
                const json = await response.json();
                if (json && json.length > 0) {
                    const result = json.map(m => bufferToBase64(m.data));
                    return { plot1: result[0], plot2: result[1] };
                }
            } 
            catch { return undefined; }
        };
       
        const fetchH5 = async () => {
            try {
                const response = await getH5PolyPlotDataAsync(runid, camera, jwt);
                if (!response.ok) return undefined;
                return await response.json();
            }
            catch { return undefined; }
        };

        try {
            const [pngData, h5Data] = await Promise.all([fetchPng(), fetchH5()]);

            let result = {};
            
            const hasH5Content = h5Data && (
                Object.keys(h5Data.plot1 || {}).length !== 0 || 
                Object.keys(h5Data.plot2 || {}).length !== 0 || 
                Object.keys(h5Data.plot3 || {}).length !== 0
            );

            if (hasH5Content) {
                result = { data: h5Data, type: 'h5' };
            }
            else if (pngData) {
                result = { data: pngData, type: 'png' };
            }

            dispatch({ 
                type: GET_POLY_PLOTS, 
                runid, 
                camera, 
                payload: result 
            });
        }
        catch {
            dispatch({ 
                type: GET_POLY_PLOTS, 
                runid, 
                camera, 
                payload: undefined 
            });
        }
        finally {
            dispatch({ type: SET_POLY_PLOTS_IS_LOADING, payload: false });
        }
    };
};

export const getFWHMPlots = (runid, imgName, jwt) => {
    return async (dispatch) => {
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        try {
            const response = await getPNGData(runid, imgName, false, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json && json.length > 0) {
                const result = json.map(m => bufferToBase64(m.data));
                
                dispatch({ 
                    type: GET_FWHM_PLOTS, 
                    payload: result, 
                    runid 
                });
            }
            else {
                dispatch({ 
                    type: GET_FWHM_PLOTS, 
                    payload: undefined, 
                    runid 
                });
            }
        } 
        catch {
            dispatch({ 
                type: GET_FWHM_PLOTS, 
                payload: undefined, 
                runid 
            });
        }
    };
};

export const setPolyPlotLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_POLY_PLOTS_IS_LOADING, payload: isLoading });
    };
}

export const setRunSummaryDensityPlotRenderData = (runid, camera, flow, data) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_SUMMARY_DENSITY_PLOT_RENDER_DATA, payload: data, runid: runid, camera: camera, flow: flow });
    };
}

export const setRunSummaryDensityPlotIsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_RUN_SUMMARY_DENSITY_PLOT_IS_LOADING, payload: isLoading, });
    };
}

export const getRunSummaryDensityPlotDataAsync = (runid, flow, instrId, jwt) => {
    const isAnalysis = runid.includes('.ver') ? runid.split('.')[0] : runid;

    return async (dispatch) => {
        dispatch({ type: SET_RUN_SUMMARY_DENSITY_PLOT_IS_LOADING, payload: true });
       
        const safeFetch = async (promise) => {
            try {
                const response = await promise;
                return response.ok ? await response.json() : undefined;
            } catch {
                return undefined;
            }
        };

        try {
            const [tileArea, histogramData] = await Promise.all([
                safeFetch(getTileAreaAsync(isAnalysis, instrId, jwt)),
                safeFetch(getHistogramPlotsDataAll(isAnalysis, flow, jwt))
            ]);
          
            if (tileArea !== undefined) {
                dispatch(setTileArea(tileArea, runid, instrId));
            }
           
            dispatch({ 
                type: GET_RUN_SUMMARY_DENSITY_PLOT_DATA, 
                payload: histogramData ?? undefined, 
                runid: Utils.getRunIdWithoutCamera(runid), 
                flow 
            });
        } 
        catch {
            dispatch({ 
                type: GET_RUN_SUMMARY_DENSITY_PLOT_DATA, 
                payload: undefined, 
                runid: Utils.getRunIdWithoutCamera(runid), 
                flow 
            });
        } 
        finally {
            dispatch({ type: SET_RUN_SUMMARY_DENSITY_PLOT_IS_LOADING, payload: false });
        }
    };
};

export const setRunSummaryDensityPlotByCameraValue = (value) => {
    return async dispatch => {
        dispatch({ type: RUN_SUMMARY_DENSITY_PLOT_BY_CAMERA_VALUE, payload: value });
    };
}

export const setVersion = (value) => {
    return async dispatch => {
        dispatch({ type: SET_VERSION, payload: value, });
    };
}

export const setBeadsFilteringPlotIsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_BEADS_FILTERING_PLOTS_IS_LOADING, payload: isLoading });
    };
}


export const setReadsFilteringPlotByCameraValue = (value) => {
    return async dispatch => {
        dispatch({ type: READS_FILTERING_PLOT_BY_CAMERA_VALUE, payload: value });
    };
}

export const setFMetricsDataIsLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: SET_FMETRICS_DATA_IS_LOADING, payload: isLoading });
    };
}

export const geCoveragePlotsData = (runid, imgName, jwt) => {
    return async (dispatch) => {
        dispatch({ type: GET_COVERAGE_PLOTS_DATA_IS_LOADING, payload: true });

        try {
            const response = await getJSONData(runid, imgName, false, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json) {
                dispatch({ 
                    type: GET_COVERAGE_PLOTS_DATA, 
                    payload: json 
                });
            }
        } 
        catch { } 
        finally {
            dispatch({ type: GET_COVERAGE_PLOTS_DATA_IS_LOADING, payload: false });
        }
    };
};

export const getChartViewPlotsData = (start_date, end_date, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_CHART_VIEW_PLOTS_DATA_IS_LOADING, payload: true });

        try {
            const response = await getRunDataByDate(start_date, end_date, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json) {
                dispatch({ 
                    type: GET_CHART_VIEW_PLOTS_DATA, 
                    payload: json 
                });
            }
        } 
        catch { } 
        finally {
            dispatch({ type: SET_CHART_VIEW_PLOTS_DATA_IS_LOADING, payload: false });
        }
    };
};

export const getBaseQualityBerPerFlowPlot = (runid, imgName, isRunBarcoded, jwt) => {
    return async (dispatch) => {
        const bufferToBase64 = (buffer) => {
            const bytes = new Uint8Array(buffer);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        };

        try {
            const response = await getPNGData(runid, imgName, isRunBarcoded, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json && json.length > 0) {
                const result = json.map(m => bufferToBase64(m.data));
                
                dispatch({ 
                    type: GET_BASE_QUALITY_BER_PER_FLOW_PLOT, 
                    payload: result[0], 
                    runid 
                });
            }
            else {
                dispatch({ 
                    type: GET_BASE_QUALITY_BER_PER_FLOW_PLOT, 
                    payload: undefined, 
                    runid 
                });
            }
        } 
        catch {
            dispatch({ 
                type: GET_BASE_QUALITY_BER_PER_FLOW_PLOT, 
                payload: undefined, 
                runid 
            });
        }
    };
};

export const setAlert = (errorMessage, errorCode, errorType) => {
    return async dispatch => {
        dispatch({ type: SET_ALERT, payload: { errorMessage: errorMessage, errorCode: errorCode, errorType: errorType } });
    };
}

export const clearAlert = () => {
    return async dispatch => {
        dispatch({ type: CLEAR_ALERT, payload: { errorMessage: '', errorCode: '', errorType: '' } });
    };
}

export const setUnifiedRowSelected = (isSelected) => {
    return async dispatch => {
        dispatch({ type: SET_IS_UNIFIED_ROW_SELECTED, payload: isSelected });
    };
}

export const getHomoIndelError = (runid, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getHomoIndelErrorAsync(runid, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: GET_HOMO_INDEL_ERROR, 
                payload: json ?? undefined 
            });
        } 
        catch {
            dispatch({ 
                type: GET_HOMO_INDEL_ERROR, 
                payload: undefined 
            });
        }
    };
};

export const addPlotlyPlotToList = (name) => {
    return async dispatch => {
        dispatch({ type: ADD_PLOTLY_PLOT_TO_LIST, payload: name });
    };
}

export const getFWHMCSVData = (runId, camera, jwt) => {
    return async (dispatch) => {
        try {
            const response = await getFWHMCSVDataAsync(runId, camera, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json) {
                dispatch({ 
                    type: GET_FWHM_CSV_DATA, 
                    payload: json 
                });
            }
        } 
        catch { }
    };
};

export const setByCameraValueGlobal = (value) => {
    return async dispatch => {
        dispatch({ type: SET_BY_CAMERA_VALUE, payload: value });
    };
}

export const setShowFrozenHeader = (show) => {
    return async dispatch => {
        dispatch({ type: SET_SHOW_FROZEN_HEADER, payload: show });
    };
}

export const setValidData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_VALID_DATA, payload: data });
    };
}

export const setValidH5PlotData = (data) => {
    return async dispatch => {
        dispatch({ type: SET_H5PLOTS_VALID_DATA, payload: data });
    };
}

export const setValidDataStatus = (status) => {
    return async dispatch => {
        dispatch({ type: VALIDATION_STATUS, payload: status });
    };
}

export const setValidDataLoading = (isLoading) => {
    return async dispatch => {
        dispatch({ type: IS_VALID_DATA_LOADING, payload: isLoading });
    }
}
export const setJWT = (jwt) => {
    return async dispatch => {
        dispatch({ type: SET_JWT, payload: jwt });
    };
}

export const setJWTExp = (exp) => {
    return async dispatch => {
        dispatch({ type: SET_JWT_EXP, payload: exp });
    };
}

export const getRunInfoData = (jwt) => {
    return async (dispatch) => {
        try {
            const response = await getRunInfoDataAsync(jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json) {
                dispatch({ 
                    type: GET_RUNINFO_DATA, 
                    payload: json.length 
                });
            }
        } 
        catch { }
    };
};

export const getRunInfoLengthData = (jwt) => {
    return async (dispatch) => {
        try {
            const response = await getRunInfoLengthDataAsync(jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json) {
                dispatch({ 
                    type: GET_RUNINFO_DATA, 
                    payload: json 
                });
            }
        } 
        catch { }
    };
};

export const getDiskSpacData = (jwt) => {
    return async (dispatch) => {
        try {
            const response = await getDiskSpaceDataAsync(jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json?.availableStorage) {
                const availableStorage = json.availableStorage;
                const [valueStr, unit] = availableStorage.split(' ');
                const spaceValue = parseFloat(valueStr);

                let result;                
                
                switch (unit) {
                    case 'TB':
                        result = Math.floor((spaceValue * 1024) / 2);
                        break;
                    case 'GB':
                        result = Math.floor(spaceValue / 2);
                        break;
                    case 'MB':
                        result = Math.floor((spaceValue / 1024) / 2);
                        break;
                    default:
                        result = undefined;
                }

                if (result !== undefined) {
                    dispatch({ type: GET_DISKSPACE, payload: result });
                }
            }
        } 
        catch { }
    };
};

export const setCustomStorageValues = (values) => {
    return async dispatch => {
        dispatch({ type: SET_CUSTOM_STORAGE, payload: values });
    };
};

export const setAlertStorageRun = (status) => {
    return async dispatch => {
        dispatch({ type: SET_ALERT_STORAGE_RUN, payload: status });
    };
}

export const calculcateStorageFreeSpace = (data, jwt) => {
    return async (dispatch) => {
        try {
            const parseData = typeof data === 'string' ? JSON.parse(data) : data;
            
            const response = await getCalculatedFreeSpaceeDataAsync(parseData, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const res = await response.json();
            
            const result = Object.keys(res).length > 0 ? res.n : undefined;

            dispatch({ 
                type: CALCULATED_CUSTOM_STORAGE_SPACE, 
                payload: result 
            });
        }
        catch (error) {
            dispatch({ 
                type: DELETE_RUN_REQUEST_STATUS, 
                payload: error.message || error.errorMessage 
            });
        }
    };
};

export const setBarcodeDetailsButton = (data) => {
    return async dispatch => {
        dispatch({ type: ACTIVE_BARCODE_TABLE_BUTTON, payload: data });
    }
}

export const addPlotlyURIList = (data) => {
    return async dispatch => {
        dispatch({ type: ADD_PLOTLY_URI_LIST, payload: data });
    };
}

export const setRunDetailsTablePdf = (runid, data) => {
    return async dispatch => {
        dispatch({ type: ADD_RUN_DETAILS_TABLE_PDF, payload: { data, runid } });
    }
}

export const setBeadsFilterTablePdf = (data) => {
    return async dispatch => {
        dispatch({ type: ADD_BEADS_FFILTER_TABLE_PDF, payload: data });
    }
}

export const setTimeZone = (timezone) => {
    return async dispatch => {
        dispatch({ type: TIME_ZONE_SELECTED, payload: timezone });
    };
}

export const getRunIdDataAllByDateAsync = (start_date, end_date, jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_IMPORT_FIELD_LOADING, payload: true });

        try {
            const response = await getRunIdDataByDate(start_date, end_date, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: POPULATE_RUNIDS, 
                payload: json 
            });
        } 
        catch {
            dispatch({ 
                type: POPULATE_RUNIDS, 
                payload: [] 
            });
        } 
        finally {
            dispatch({ type: SET_IS_IMPORT_FIELD_LOADING, payload: false });
        }
    };
};

export const setPopulateRuns = (data) => {
    return async dispatch => {
        dispatch({ type: POPULATE_RUNIDS, payload: data });
    };
}

export const deleteRunIdListData = (runIdsArray, jwt) => {
    return async (dispatch) => {
        localStorage.setItem("delete_run_request_status", true);
        dispatch({ type: DELETE_RUN_REQUEST_STATUS, payload: true });

        const requestData = { data: runIdsArray };

        try {
            const response = await deleteRunIdsDataAsync(requestData, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const res = await response.json();

            if (res) {
                sessionStorage.setItem('delete_complete_message', 'Data has been successfully deleted');
            }
        } 
        catch (error) {
            console.error("Delete operation failed:", error);
        } 
        finally {
            localStorage.setItem("delete_run_request_status", false);
            dispatch({ type: DELETE_RUN_REQUEST_STATUS, payload: false });
        }
    };
};

export const getPpmSeqReportList = (runid, barcode, jwt) => {
    return async (dispatch) => {
        dispatch({ type: CHECK_PPM_DATA_IS_LOADING, payload: true });

        try {
            const response = await getPpmSeqReportListDataAsync(runid, barcode, jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

           if (json) {
                dispatch({ 
                    type: GET_PPMSEQ_REPORT_LIST, 
                    payload: json ?? undefined 
                });
            }
        } 
        catch (error) {
            console.error(`getPpmSeqReportList error: ${error.message}`);
        } 
        finally {
            dispatch({ type: CHECK_PPM_DATA_IS_LOADING, payload: false });
        }
    };
};

export const setColumnType = (column) => {
    return async dispatch => {
        dispatch({ type: SET_COLUMN_TYPE, payload: column });
    };
}

export const setBarcodeCoverageBarcode = (barcode) => {
    return async dispatch => {
        dispatch({ type: SET_BARCODE_COVERAGE_BARCODE, payload: barcode });
    };
}

export const setExpandedRunId = (data) => {
    return async dispatch => {
        dispatch({ type: SET_EXPANDED_RUNID, payload: data });
    };
};

export const clearExpandedRunId = (runId) => {
    return async dispatch => {
        dispatch({ type: CLEAR_EXPANDED_RUNID, payload: runId });
    };
};

export const getOTDataAsync = (jwt) => {
    return async (dispatch) => {
        dispatch({ type: SET_IS_OT_DATA_LOADING, payload: true });

        try {
            const response = await getOTData(jwt);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();

            dispatch({ 
                type: LOAD_OT_LIST_DATA, 
                payload: json 
            });
        } 
        catch { } 
        finally {
            dispatch({ type: SET_IS_OT_DATA_LOADING, payload: false });
        }
    };
};

export const setSearchTermOT = (searchWords, searchColumn) => {
    return async dispatch => {
        dispatch({ type: SET_SEARCH_TERM_OT, payload: { searchWords, searchColumn } });
    };
}

export const setOTRunId = (runId) => {
    return async dispatch => {
        dispatch({ type: SET_OT_RUN_ID, payload: runId });
    };
}